import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_2jkKRPlb6cY2: {
	id: 'prd_2jkKR2DEV2Plb6cY2'
	ident: 'prd_2jkKRPlb6cY2'
	sku: 'simple_premium_12w_19_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_au6zs2DEV2WnDUqeu'
			amount: 79
			amount_usd: 19.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 19.99
			discount: 59.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_Dv95B2DEV2cTCFWEF'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_2jkKRPlb6cY2, SubscriptionProduct>
const prd_2jkKRPlb6cY2 = { ident: 'prd_2jkKRPlb6cY2' } as typeof _prd_2jkKRPlb6cY2

export default prd_2jkKRPlb6cY2
